import { ColumnCenter } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled from "styled-components"

import comingsoongIcon from 'assets/images/empty.png'
import { ContactUsCom } from "Layouts/components/pc/BottomCom"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
const EmptyPage = () => {
    const location = useLocation()
    const [moduleName, setModuleName] = useState('')
    useEffect(() => {
      let name = ''
      const pathName = location.pathname
      if(pathName.includes('orders')) {
        name = 'A redesigned order module will be available shortly'
      } else if(pathName.includes('referrals')) {
        name = 'A redesigned referrals module will be available shortly'
      } else if(pathName.includes('settings')){
        name = 'A redesigned settings module will be available shortly'
      } else {
        name = 'A mobile optimised version will be available shortly, please use the old version'
      }
      setModuleName(name)
    }, [location])

    return <EmptyWrap>
        <EmptyColumn></EmptyColumn>
        <OutWrap>
            <ComingSoonWrap>
              <ComingSoonImgWrap src={comingsoongIcon}></ComingSoonImgWrap>
              <StyledContainer $mt="30px" $mb="16px" $fontSize="18px" $lineHeight="20px">{moduleName}</StyledContainer>
              {/* {
                moduleName.includes('mobile') && <StyledContainer $mb="16px">
                  <a href="https://old.dapp.chainge.finance" rel="noreferrer" style={{fontSize: '16px'}}>https://old.dapp.chainge.finance</a>
                </StyledContainer>
              } */}
              <StyledContainer $fontSize="16px" $lineHeight="18px" $fontWeight4 $mb="30px" $color="#767A7F">Stay tuned for our official announcements</StyledContainer>
              <ContactUsCom></ContactUsCom>
            </ComingSoonWrap>         
        </OutWrap>
    </EmptyWrap>
}

const EmptyWrap = styled(StyledContainer)`
    display: flex;
    min-height: 100vh;
    flex: 1;
`

const EmptyColumn = styled(StyledContainer)`
  flex: 1;

  @media screen and (min-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1440px) and (max-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1024px) and (max-width: 1440px) {
    flex: 1;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    flex: none;
    width: 24px;    
  }
  @media screen and (max-width: 768px) {
    flex: none;
  }
`

const OutWrap = styled(StyledContainer)`
  flex: 9;
  background-color: ${({theme}) => theme.basicWhite};
  position: relative;
`

const ComingSoonWrap = styled(ColumnCenter)`
  margin-top: 150px;
  text-align: center;
`

const ComingSoonImgWrap = styled.img`
  height: 140px;
`

export default EmptyPage